import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { icons } from "utils/constants";
import { useSelector } from "react-redux";
import { SubscriptionButton } from "components";
import "./Sidebar.scss";

const Sidebar = ({ handleLogout }) => {
  const navigate = useNavigate();
  const [show, seShow] = useState(false);
  const reduxData = useSelector((state) => state.global);
  const { isSubscription, isDarkMode } = reduxData;

  const sidebarOption = [
    {
      title: "Dashboard",
      url: "dashboard",
      menuIcons: icons.dashboard,
      activeMenuIcons: isDarkMode
        ? icons.activedashBoardDark
        : icons.activeDashboard,
      show: true,
    },
    {
      title: "My Projects",
      url: "my-projects",
      menuIcons: icons.myProject,
      activeMenuIcons: isDarkMode
        ? icons.activeMyProjectLight
        : icons.activeMyProject,
      show: true,
    },
    {
      title: "Subscription",
      url: "subscription",
      menuIcons: icons.subscription,
      activeMenuIcons: isDarkMode
        ? icons.activeSubscriptionLight
        : icons.activeSubscription,
      show: true,
    },
    {
      title: "Transaction",
      url: "transaction",
      menuIcons: icons.transaction,
      activeMenuIcons: isDarkMode
        ? icons.activeTransactiondark
        : icons.activeTransaction,
      // show: isSubscription,
      show: true,
    },
    {
      title: "Admin",
      url: "admin",
      menuIcons: icons.admin,
      activeMenuIcons: isDarkMode ? icons.activeAdminLight : icons.activeAdmin,
      show: true,
    },
    {
      title: "Usage",
      url: "usage",
      menuIcons: icons.usage,
      activeMenuIcons: isDarkMode ? icons.activeUsageLight : icons.activeUsage,
      show: isSubscription,
    },
    // {
    //   title: "Superfluid",
    //   url: "superfluid",
    //   menuIcons: icons.superfluid,
    //   activeMenuIcons: icons.superfluid,
    //   show: isSubscription,
    // },
  ];
  useEffect(() => {
    setTimeout(() => {
      seShow(true);
    }, 1000);
  }, []);

  return (
    <div id={`${isDarkMode ? "sidebar-container-dark" : "sidebar-container"}`}>
      <div className={`cpt-22 cpb-22 ${isDarkMode ? "bb-4d6c" : " bb-dee3"}`}>
        <div
          className="h-35 pointer position-relative"
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          <img
            src={isDarkMode ? icons.logoDark : icons.logo}
            alt="logo"
            className="fit-image"
          />
          <p
            className={`position-absolute ${
              isDarkMode ? "color-ffff" : "color-7e91"
            } text-12-400 version`}
          >
            v1.87
          </p>
        </div>
      </div>
      <div className="flex-grow-1 d-flex flex-column">
        <div className="side-option-container cpt-20 flex-grow-1">
          {sidebarOption.map((elm, index) => {
            const { title, url, menuIcons, activeMenuIcons, show } = elm;
            const isActiveMenu = window.location.pathname.includes(url);
            return (
              <div
                key={index}
                className={`side-menu-block ${
                  isActiveMenu ? "active-side-menu" : ""
                } ${show ? "" : "d-none"}`}
                onClick={() => {
                  if (!isActiveMenu) {
                    if (url === "superfluid") {
                      window.open(
                        "https://app.superfluid.finance/token/sepolia/0x783fdeab6951504c4601184587aafed01511ed24",
                        "_blank"
                      );
                    } else {
                      navigate(`/${url}`);
                    }
                  }
                }}
              >
                <span className="side-icon-block">
                  <img
                    src={isActiveMenu ? activeMenuIcons : menuIcons}
                    alt="menuIcons"
                    className="fit-image"
                  />
                </span>
                <span className="side-title-block">{title}</span>
              </div>
            );
          })}
        </div>
        <div className="cps-36 pb-3 cpe-20">
          {!isSubscription && show && <SubscriptionButton />}
          <div
            className="fa-center un pt-3 pb-3 pointer mt-1"
            onClick={handleLogout}
          >
            <span className="h-22">
              <img
                src={isDarkMode ? icons.logoutDark : icons.logout}
                alt="logout"
                className="fit-image"
              />
            </span>
            <span
              className={`text-18-400 ${
                isDarkMode ? "color-c9c9" : "color-7e91"
              } ms-2`}
            >
              Log out
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
